/*!
 * MUU v1.1.14
 * Unified UI framework for MaiHaoChe.com
 * https://maihaoche.github.io/muu/
 *
 * Copyright 2017, Ourai Lin <ourairyu@gmail.com> (http://ourai.ws/)
 * Released under the MIT license.
 *
 * 00000000000000000000000000000000000000000000000000
 * 000000000000000000000GCft1tf1tLC000000000000000000
 * 00000000000000000LLf1i1i;t1t11i1itL000000000000000
 * 000000000000000Cf111t1;ttf1tt1if11;tfC000000000000
 * 0000000000000Ciiif11;11111iitf1f1ffftitL0000000000
 * 000000000000Ci1ti11i;1i11ti1i1;i1iit1iitG000000000
 * 000000000000t;iii1i1;11tt;1ii;1iiii11ti1G000000000
 * 0000000000Gf1i:;;ii;;;;1;i:1it;11i1tti:f8000000000
 * 00000000008ti;:;ii1tfti;;;1;ii1ii:11iiCG0000000000
 * 00000000000Git;f1f1fif1;i1t:;i;1:i;:;;800000000000
 * 00000000000C:1f;t;tt11;:tfC1:tt1;i::;:G00000000000
 * 000000000008i;i1fti;:ittCfftf:i1;ti;;;180000000000
 * 0000000000008fft1ff1tittttLGL.Li1;;1;ii80000000000
 * 000000000000CfLG800Gft1tffLLLLftt1::i;;C0000000000
 * 000000000000Li00GCCGGGf1LLfCCfi1tt1;11;G0000000000
 * 0000000000000;G80080008t1CfLtt;iff1;1if00000000000
 * 0000000000008i1LLCftG08011ttt1ttfff:ii;00000000000
 * G000000000000CL11ttCtfftfi1i;ifi1;1iL;C00000000000
 * 00G0G000000000000GLtfCG8i;:;1i;1if1fLfC00000000000
 * GGGGGGGG0000000000000G;tt:ii;1ftCLffLt1G0000000000
 * GGGGGGGGGG00000000000i;;i;ittLftLtf1t;;;L000000000
 * GGGGGGGGGGGGGGGGGG00:i;;i11ifLftft;ii1tLif000000G0
 * GGGGGGGGGGGGGGGGGGG0Lt;t;f1tfi;;;:itGCCitt:1C00GGG
 * GGGGGGGGGGGGGGGGGGGGG0i11:1:i:;1tCCCCGiGiCi::f0GGG
 * GGGGGGGGGGGGGGGGGGGGGf;,i1;:tLCffCLCf,tCCi1fi,fGGG
 */

(function() {

"use strict";

function scrollSidebar() {
  var $sidebar = $(".Hui-aside");
  var $item = $(".menu_dropdown > dl.is-current:first", $sidebar);

  var sidebarOffset = $sidebar.offset();
  var itemOffset = $item.offset();

  if (sidebarOffset && itemOffset && (itemOffset.top < sidebarOffset.top || itemOffset.top > sidebarOffset.top + $sidebar.outerHeight() - $item.outerHeight())) {
    $sidebar.scrollTop($sidebar.scrollTop() + itemOffset.top - sidebarOffset.top - parseFloat($(".Menu-label", $item).css("margin-top"), 10));
  }

  var tabUrl = $sidebar.attr("data-url");

  if (tabUrl) {
    $("dt", $(".menu_dropdown > dl.is-current [data-href='" + tabUrl + "']", $sidebar).closest("dl")).trigger("click");
  }
}

function initResponsiveActions() {
  var $sidebar = $(".Hui-aside");
  var $combine = $sidebar.add(".Hui-main");

  $(".Header-toggle").on("click", function () {
    $combine.addClass("is-shown");
    $sidebar.show();

    return false;
  });

  $sidebar.on("click", function (evt) {
    var $navs = $(".menu_dropdown", $sidebar);

    if (!($.contains($navs.get(0), evt.target) || $(evt.target).is($navs))) {
      $combine.removeClass("is-shown");
      $sidebar.hide();
    }
  });
}

$(document).ready(function () {
  scrollSidebar();
  initResponsiveActions();
});

})();